import React from 'react';
import { Container, Row } from 'reactstrap';
import Breadcrumb from 'Components/Common/Breadcrumb';
import Detail from './Detail';


const SettingsRoleIndex = () => {
  document.title = "Хандах эрх";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Системийн удирдлага" breadcrumbItem="Хандах эрх" />
          <Row>
            <Detail/>
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
}

export default SettingsRoleIndex;